'use client';

import type { Illustration, IllustrationSlotName } from '@/libs/campaigns/types';
import { resolveIllustration } from '@/libs/campaigns/illustrations';
import { useActiveSkin } from '../ActiveCampaignProvider';

/** The art for an Illustration Slot: the Active Campaign's override, or the slot's default. */
export function useIllustration(slot: IllustrationSlotName): Illustration | null {
  return resolveIllustration(useActiveSkin(), slot);
}

/** Whether the Active Campaign overrides an Illustration Slot, e.g. to paint the background its art is drawn for. */
export function useHasCampaignIllustration(slot: IllustrationSlotName): boolean {
  return Boolean(useActiveSkin()?.illustrations?.[slot]);
}
